import { AsyncAction } from "../../../types/actions";

import { GetMagicLinksForEvent, GenerateMagicLinksForEvent } from "../../../connection/magic-links";
import { PasscodeListMemberType } from "../../../types/working-model";

export const GET_MAGIC_LINKS_FOR_EVENT = "GET_MAGIC_LINKS_FOR_EVENT";
export function getMagicLinksForEvent(token: string, channel: number, list_id: number, event_uuid: string): AsyncAction {
	return {
		type: GET_MAGIC_LINKS_FOR_EVENT,
		promise: GetMagicLinksForEvent(token, channel, list_id, event_uuid)
	};
}



export const GENERATE_MAGIC_LINKS_FOR_EVENT = "GENERATE_MAGIC_LINKS_FOR_EVENT";
export function generateMagicLinksForEvent(token: string, channel: number, list_id: number, event_uuid: string, selectedMembers?: PasscodeListMemberType[]): AsyncAction {
	return {
		type: GENERATE_MAGIC_LINKS_FOR_EVENT,
		promise: GenerateMagicLinksForEvent(token, channel, list_id, event_uuid, selectedMembers)
	};
}
